<script>
import DraggableColumns from './DraggableColumns.vue';

export default {
  components: {
    DraggableColumns
  },
  props: {
    area: {
      type: String,
      required: true
    },
    columns: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedArea: '',
      availableColumns: [],
      selectedColumns: []
    };
  },
  watch: {
    selectedArea() {
      const columns = this.findColumns(this.selectedArea);

      if (columns) {
        this.availableColumns = columns.allColumns;
        this.selectedColumns = columns.defaultColumns;
      }
    }
  },
  created() {
    if (this.area && this.findColumns(this.area)) {
      this.selectedArea = this.area;

      return;
    }

    // Use column data to set the area
    this.selectedArea = this.columns.length ? this.columns[0].area : '';
  },
  methods: {
    findColumns(area) {
      return this.columns.find(c => c.area === area);
    }
  }
};
</script>
